import { Link } from "react-router-dom";

export const Logo = () => {
  return (
    <div className="">
      <Link to="/dashboard">
        <img
          alt="cleancooler"
          className="w-[137px] h-20"
          src="/images/Fit-Fresh-Logo.png"
        />
      </Link>
    </div>
  );
};
